import _ from 'lodash';
import UTC from '@voicebase/unicode-char-test';

import uuid from 'uuid/v4';
import { search } from '../../utils';

const {
  TYPE_OTHER, TYPE_LETTER, TYPE_DASH, TYPE_SPACE, isMadeOf,
} = UTC;

const TOTAL_ROWS = 30;
const ROWS_AT_END = 10;

class KeywordObject {
  constructor(params) {
    this.isError = false;
    if (_.isString(params)) {
      this.keyword = params;
    } else if (_.isObject(params)) {
      this.keyword = _.get(params, 'keyword');
      this.id = _.get(params, 'id');
    }
  }

  get keyword() {
    if (!('_keyword' in this)) {
      this._keyword = '';
    }
    return this._keyword;
  }

  set keyword(value) {
    if (_.isString(value)) {
      this._keyword = _.trim(value.split(',')[0], '"');
      this.setIsError();
    }
  }

  get empty() {
    return !_.trim(this.keyword);
  }

  setIsError() {
    this.isError = false;
    this.error = '';
    if (this.empty) {
      this.isError = true;
      this.error = 'keywords cannot be empty or pure space';
    } else {
      try {
        const charTypes = isMadeOf(this.keyword, [TYPE_DASH, TYPE_SPACE, TYPE_LETTER, TYPE_OTHER]);
        if (charTypes.has(TYPE_OTHER)) {
          this.isError = true;
          this.error = 'keywords must be only letters, spaces, numbers or dashes';
        }
      } catch (err) {
        // possible if keyword is not a string
        console.log('error: ', err);
        this.isError = true;
        this.error = 'keyword is not a string';
      }
    }
  }

  get id() {
    if (!('_id' in this)) {
      this._id = uuid();
    }
    return this._id;
  }

  set id(value) {
    if (value && _.isString(value)) {
      this._id = value;
    }
  }

  has(searchTerm) {
    if (!searchTerm) {
      return true;
    }
    if (this.empty) {
      return false;
    }

    const result = search(searchTerm, this.keyword);
    return result;
  }

  static listToData(...input) {
    return _(input)
      .flattenDeep()
      .compact()
      .reject('empty')
      .map('keyword')
      .value();
  }

  /**
   * this method transforms junk data into an array of keyword objects.
   * Note - no redundancy checks are in this code.
   * @param input
   * @returns {*}
   */
  static toList(...input) {
    const cleanKeywordObjectList = _(input)
      .flattenDeep()
      .compact()
      .map((kwObject) => {
        if (!(kwObject instanceof KeywordObject)) {
          return new KeywordObject(kwObject);
        }
        return kwObject;
      })
      .reject('empty')
      .value();
    while ((cleanKeywordObjectList.length < TOTAL_ROWS)
    || cleanKeywordObjectList.slice(-ROWS_AT_END).filter(a => !a.empty).length) {
      cleanKeywordObjectList.push(new KeywordObject());
    }
    return cleanKeywordObjectList;
  }
}

export default KeywordObject;
